module.exports = __webpack_public_path__ + "img/dash1.0c12bfb3.webp";